// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/learning/PreviousResolutionCard.jsx

import React from 'react';

const formatPercent = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return '—';
  return `${n % 1 === 0 ? n.toFixed(0) : n.toFixed(1)}%`;
};

export default function PreviousResolutionCard({ recall = {}, outcomes = {} }) {
  const hasRecall = recall?.available || outcomes?.available;

  return (
    <section className="learning-card previous-resolution-card">
      <div className="learning-card-header">
        <div>
          <p className="learning-eyebrow">Similar Work</p>
          <h4>Previous Resolution Memory</h4>
        </div>
        <span className={`learning-status-pill ${hasRecall ? 'learning-status-pill-active' : ''}`}>
          {hasRecall ? 'Available' : 'No prior signal'}
        </span>
      </div>

      <div className="learning-metric-grid learning-metric-grid-four">
        <div className="learning-mini-metric">
          <span>Matches</span>
          <strong>{recall?.matches ?? outcomes?.completed_count ?? 0}</strong>
        </div>
        <div className="learning-mini-metric">
          <span>Avg Resolution</span>
          <strong>{recall?.average_resolution_minutes ?? outcomes?.average_completion_minutes ?? '—'}m</strong>
        </div>
        <div className="learning-mini-metric">
          <span>Validation Success</span>
          <strong>{formatPercent(recall?.validation_success_rate ?? 0)}</strong>
        </div>
        <div className="learning-mini-metric">
          <span>Rollback Frequency</span>
          <strong>{recall?.rollback_frequency ?? outcomes?.rollback_count ?? 0}</strong>
        </div>
      </div>

      {recall?.most_successful_path ? (
        <div className="learning-callout learning-callout-success">
          <span>Most successful path</span>
          <p>{recall.most_successful_path}</p>
        </div>
      ) : null}

      {Array.isArray(recall?.common_blockers) && recall.common_blockers.length > 0 ? (
        <div className="learning-chip-row" aria-label="Common blockers">
          {recall.common_blockers.map((blocker) => (
            <span className="learning-chip learning-chip-warning" key={blocker}>{blocker}</span>
          ))}
        </div>
      ) : null}

      {recall?.learning_note ? <p className="learning-muted-copy">{recall.learning_note}</p> : null}
    </section>
  );
}
